import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.draws');
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

interface DrawPrize {
    prize_rank: number;
    winning_criteria: string;
    winner_count: number;
    prize_per_winner: number;
    official_prize_total: number;
}

interface StoreSummary {
    prize_rank: number;
    purchase_method: string | null;
    store_count: number;
}

interface WinningStore {
    id: number;
    sequence_no: number;
    store_name: string | null;
    province: string;
    district: string;
    full_address: string;
    phone: string | null;
    winning_count: number;
    method_counts: Array<{
        method: string;
        count: number;
    }>;
}

interface DrawSummary {
    draw_no: number;
    draw_date: string;
    numbers: number[];
    bonus: number;
    first_winner_count: number;
    first_prize_per_winner: number;
}

interface DrawDetail extends DrawSummary {
    first_prize_auto_count: number;
    first_prize_manual_count: number;
    first_prize_semi_auto_count: number;
    first_prize_method_available: boolean;
    total_sales_amount: number;
    total_winner_count: number;
    source_url: string;
    prizes: DrawPrize[];
    store_summary: StoreSummary[];
}

interface DrawOption {
    draw_no: number;
    draw_date: string;
}

interface SyncStatus {
    status: string;
    message?: string;
    started_at?: string;
    finished_at?: string;
}

@Component({
    selector: 'wiz-page-draws',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.draws/view.scss */
:host {
  display: block;
}

.latest-draw-card {
  background: #fffdf5;
}

.draw-picker-trigger {
  display: inline-flex;
  min-height: 2.6rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 0.42rem;
  padding: 0 0.85rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.85rem;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
  color: #0f172a;
  font-size: 0.6875rem;
  font-weight: 900;
  transition: border-color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
}

.draw-picker-trigger svg {
  width: 1rem;
  height: 1rem;
  color: #64748b;
}

.draw-picker-trigger:hover {
  border-color: #cbd5e1;
  box-shadow: 0 7px 18px rgba(15, 23, 42, 0.09);
  transform: translateY(-1px);
}

.draw-picker-trigger:active {
  transform: scale(0.97);
}

.draw-picker-trigger:disabled {
  cursor: not-allowed;
  opacity: 0.48;
  transform: none;
}

.draw-picker-modal-layer {
  position: fixed;
  inset: 0 0 calc(4rem + max(0.5rem, env(safe-area-inset-bottom)));
  z-index: 65;
}

.draw-picker-modal-backdrop {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  background: rgba(15, 23, 42, 0.42);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  animation: reveal-draw-detail-backdrop 0.18s ease-out both;
}

.draw-picker-modal-viewport {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: flex-end;
  justify-content: center;
  padding: 0.5rem;
  pointer-events: none;
}

.draw-picker-modal-panel {
  display: flex;
  width: 100%;
  max-height: 100%;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 1.5rem;
  background: rgba(248, 250, 252, 0.97);
  box-shadow: 0 -16px 52px rgba(15, 23, 42, 0.2);
  pointer-events: auto;
  backdrop-filter: saturate(150%) blur(24px);
  -webkit-backdrop-filter: saturate(150%) blur(24px);
  animation: reveal-draw-detail 0.22s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.draw-picker-sheet-handle {
  width: 2.25rem;
  height: 0.25rem;
  flex: 0 0 auto;
  margin: 0.48rem auto 0.1rem;
  border-radius: 9999px;
  background: rgba(100, 116, 139, 0.34);
}

.draw-picker-modal-header {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 0.85rem 0.8rem 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.draw-picker-modal-header h2 {
  color: #0f172a;
  font-size: 1rem;
  font-weight: 900;
  letter-spacing: -0.025em;
}

.draw-picker-modal-header p {
  margin-top: 0.08rem;
  color: #94a3b8;
  font-size: 0.625rem;
  font-weight: 700;
}

.draw-picker-modal-close {
  display: inline-flex;
  width: 2.4rem;
  height: 2.4rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.84);
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.08);
  color: #64748b;
  font-size: 1rem;
}

.draw-picker-modal-body {
  min-height: 0;
  overflow-y: auto;
  padding: 0.9rem;
  overscroll-behavior: contain;
}

.draw-picker-section-title {
  margin: 0 0 0.5rem 0.15rem;
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 900;
}

.draw-picker-recent-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
}

.draw-picker-recent-item {
  display: flex;
  min-width: 0;
  min-height: 3.55rem;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 0.65rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.85rem;
  background: #fff;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.035);
  text-align: left;
  transition: border-color 0.15s ease, background-color 0.15s ease, transform 0.15s ease;
}

.draw-picker-recent-item:first-child {
  border-color: #fbbf24;
  background: #fffbeb;
}

.draw-picker-recent-item:hover {
  border-color: #94a3b8;
  transform: translateY(-1px);
}

.draw-picker-recent-item:active {
  background: #f1f5f9;
  transform: scale(0.98);
}

.draw-picker-recent-item:disabled {
  cursor: wait;
  opacity: 0.55;
}

.draw-picker-recent-item strong {
  color: #0f172a;
  font-size: 0.75rem;
  font-weight: 900;
}

.draw-picker-recent-item time {
  margin-top: 0.12rem;
  color: #94a3b8;
  font-size: 0.625rem;
  font-weight: 700;
}

.draw-picker-direct {
  margin-top: 0.9rem;
}

.draw-picker-direct-control {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.95rem;
  background: #fff;
}

.draw-picker-direct-control > span {
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 900;
}

.draw-picker-direct-control > span:first-child {
  padding-left: 0.35rem;
}

.draw-picker-direct-control input {
  min-width: 0;
  height: 2.55rem;
  border: 0;
  background: transparent;
  color: #0f172a;
  font-size: 1rem;
  font-weight: 900;
  text-align: center;
  font-variant-numeric: tabular-nums;
}

.draw-picker-direct-control input::placeholder {
  color: #cbd5e1;
}

.draw-picker-direct-control button {
  min-height: 2.55rem;
  padding: 0 1rem;
  border-radius: 0.7rem;
  background: #0f172a;
  color: #fff;
  font-size: 0.6875rem;
  font-weight: 900;
}

.draw-picker-direct-control button:disabled {
  opacity: 0.5;
}

.draw-surface,
.draw-list-shell {
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.035), 0 8px 24px rgba(15, 23, 42, 0.025);
}

.draw-surface {
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.draw-surface:hover {
  box-shadow: 0 2px 4px rgba(15, 23, 42, 0.04), 0 10px 28px rgba(15, 23, 42, 0.04);
}

.draw-card-grid {
  display: grid;
  grid-template-areas: "round" "numbers";
  grid-template-columns: minmax(0, 1fr);
  align-items: center;
  gap: 0.45rem;
}

.draw-round {
  grid-area: round;
}

.draw-numbers {
  grid-area: numbers;
}

.draw-card-button {
  transition: background-color 0.16s ease, transform 0.16s ease;
}

.draw-card-button:hover {
  background: rgba(248, 250, 252, 0.72);
}

.draw-card-button:active {
  background: rgba(241, 245, 249, 0.9);
  transform: scale(0.997);
}

.draw-card-button:disabled {
  cursor: wait;
  opacity: 0.62;
}

.draw-date {
  display: inline-flex;
  min-height: 1.75rem;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.3rem;
  padding: 0 0.55rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.55rem;
  background: #f8fafc;
  color: #475569;
  font-size: 0.6875rem;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.015em;
  white-space: nowrap;
}

.draw-date svg {
  width: 0.8rem;
  height: 0.8rem;
  color: #94a3b8;
}

.latest-draw-card .draw-date {
  border-color: #fde68a;
  background: #fffbeb;
  color: #92400e;
}

.latest-draw-card .draw-date svg {
  color: #d97706;
}

.number-row {
  display: flex;
  width: 100%;
  max-width: 27rem;
  align-items: center;
  justify-content: space-between;
  gap: 0.25rem;
}

.lotto-ball {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.28);
  font-size: 0.68rem;
  font-weight: 900;
  letter-spacing: -0.02em;
}

.bonus-plus {
  display: inline-flex;
  width: 0.7rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  color: #ef4444;
  font-size: 1.05rem;
  font-weight: 900;
  line-height: 1;
}

.bonus-group {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0.16rem;
  border: 1px solid #fca5a5;
  border-radius: 0.55rem;
  background: #fff1f2;
}

.ball-yellow {
  background: #fbbf24;
  color: #0f172a;
}

.ball-blue {
  background: #3b82f6;
  color: #fff;
}

.ball-red {
  background: #ef4444;
  color: #fff;
}

.ball-gray {
  background: #64748b;
  color: #fff;
}

.ball-green {
  background: #10b981;
  color: #fff;
}

.money-value {
  min-width: 0;
  overflow-wrap: anywhere;
  font-variant-numeric: tabular-nums;
}

.prize-row {
  display: grid;
  grid-template-columns: 2.25rem minmax(0, 1fr);
  column-gap: 0.55rem;
}

.prize-rank {
  grid-column: 1;
}

.prize-criteria {
  grid-column: 2;
}

.prize-result {
  display: flex;
  grid-column: 2;
  min-width: 0;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 0.3rem;
}

.draw-detail-modal-layer {
  position: fixed;
  inset: 0 0 calc(4rem + max(0.5rem, env(safe-area-inset-bottom)));
  z-index: 60;
}

.draw-detail-modal-backdrop {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  background: rgba(15, 23, 42, 0.48);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  animation: reveal-draw-detail-backdrop 0.18s ease-out both;
}

.draw-detail-modal-viewport {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: flex-end;
  justify-content: center;
  padding: 0 0.5rem 0.5rem;
  pointer-events: none;
}

.draw-detail-modal-panel {
  display: flex;
  width: 100%;
  max-height: 100%;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 1.5rem;
  background: rgba(248, 250, 252, 0.97);
  box-shadow: 0 -16px 52px rgba(15, 23, 42, 0.2);
  pointer-events: auto;
  backdrop-filter: saturate(150%) blur(24px);
  -webkit-backdrop-filter: saturate(150%) blur(24px);
  animation: reveal-draw-detail 0.22s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.draw-detail-sheet-handle {
  width: 2.25rem;
  height: 0.25rem;
  flex: 0 0 auto;
  margin: 0.48rem auto 0.1rem;
  border-radius: 9999px;
  background: rgba(100, 116, 139, 0.34);
}

.draw-detail-modal-header {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 0.85rem 0.8rem 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.draw-detail-modal-close {
  display: inline-flex;
  width: 2.4rem;
  height: 2.4rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.08);
  color: #64748b;
  font-size: 1rem;
  transition: background-color 0.15s ease, color 0.15s ease, transform 0.15s ease;
}

.draw-detail-modal-close:hover {
  background: #fff;
  color: #0f172a;
}

.draw-detail-modal-close:active {
  transform: scale(0.96);
}

.draw-detail-modal-body {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 0.8rem;
  overscroll-behavior: contain;
}

.draw-detail-winning-card {
  padding: 0.85rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.9rem;
  background: #fff;
}

.detail-number-row {
  max-width: none;
  justify-content: center;
}

.draw-detail-modal-footer {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.7rem 0.8rem;
  border-top: 1px solid #e2e8f0;
  background: rgba(255, 255, 255, 0.92);
}

.store-modal-panel {
  animation: reveal-store-modal 0.18s ease-out;
  box-shadow: 0 -12px 48px rgba(15, 23, 42, 0.18);
}

.store-address {
  overflow-wrap: anywhere;
}

.store-modal-footer {
  padding-bottom: max(0.75rem, env(safe-area-inset-bottom));
}

button:focus-visible,
a:focus-visible,
select:focus-visible,
input:focus-visible {
  outline: 3px solid rgba(251, 191, 36, 0.55);
  outline-offset: 2px;
}

@keyframes reveal-draw-detail-backdrop {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes reveal-draw-detail {
  from {
    opacity: 0.72;
    transform: translateY(1rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes reveal-store-modal {
  from {
    opacity: 0;
    transform: translateY(0.6rem) scale(0.99);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 359px) {
  .draw-date {
    padding: 0 0.45rem;
    font-size: 0.625rem;
  }
  .draw-date svg {
    display: none;
  }
  .lotto-ball {
    width: 1.65rem;
    height: 1.65rem;
    font-size: 0.625rem;
  }
}
@media (max-width: 639px) {
  .draw-detail-modal-viewport {
    padding: 0.5rem;
  }
  .draw-detail-modal-panel .prize-row {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}
@media (max-width: 319px) {
  .number-row {
    gap: 0.2rem;
  }
  .lotto-ball {
    width: 1.5rem;
    height: 1.5rem;
    font-size: 0.625rem;
  }
}
@media (min-width: 640px) {
  .draw-picker-modal-layer {
    inset: 0;
  }
  .draw-picker-modal-viewport {
    align-items: center;
    padding: 1rem;
  }
  .draw-picker-modal-panel {
    width: min(100%, 28rem);
    max-height: min(38rem, 100dvh - 2rem);
    box-shadow: 0 26px 72px rgba(15, 23, 42, 0.24);
  }
  .draw-picker-sheet-handle {
    display: none;
  }
  .draw-picker-modal-header {
    padding: 1rem 1rem 1rem 1.15rem;
  }
  .draw-picker-modal-body {
    padding: 1rem;
  }
  .draw-picker-recent-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .draw-detail-modal-layer {
    inset: 0;
  }
  .draw-detail-modal-viewport {
    align-items: center;
    padding: 1rem;
  }
  .draw-detail-modal-panel {
    width: min(100%, 38rem);
    max-height: min(46rem, 100dvh - 2rem);
    box-shadow: 0 26px 72px rgba(15, 23, 42, 0.24);
  }
  .draw-detail-sheet-handle {
    display: none;
  }
  .draw-detail-modal-header {
    padding: 1rem 1rem 1rem 1.15rem;
  }
  .draw-detail-modal-body {
    padding: 1rem;
  }
  .draw-detail-modal-footer {
    padding: 0.8rem 1rem;
  }
  .draw-card-grid {
    grid-template-areas: "round numbers";
    grid-template-columns: minmax(14rem, auto) minmax(16rem, 1fr);
    gap: 0.55rem 0.875rem;
  }
  .store-modal-panel {
    box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);
  }
  .store-modal-footer {
    padding-bottom: 0.75rem;
  }
  .number-row {
    gap: 0.45rem;
    justify-content: flex-start;
  }
  .bonus-group {
    margin-left: 0.1rem;
    padding: 0.18rem;
  }
  .prize-row {
    grid-template-columns: 2.5rem minmax(0, 1fr) auto;
    align-items: center;
    column-gap: 0.75rem;
  }
  .prize-result {
    grid-column: 3;
    min-width: 14rem;
    justify-content: flex-end;
    gap: 1.5rem;
    margin-top: 0;
    text-align: right;
  }
}
@media (min-width: 900px) {
  .draw-card-grid {
    grid-template-areas: "round numbers";
    grid-template-columns: 15rem minmax(17rem, 1fr);
    gap: 0.75rem;
  }
  .lotto-ball {
    width: 2.15rem;
    height: 2.15rem;
    font-size: 0.72rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .draw-picker-modal-backdrop,
  .draw-picker-modal-panel,
  .draw-detail-modal-backdrop,
  .draw-detail-modal-panel,
  .store-modal-panel {
    animation: none;
  }
}`],
})
export class PageDrawsComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public loadingMore: boolean = false;
    public findingDrawNo: number | null = null;
    public drawPickerOpen: boolean = false;
    public draws: DrawSummary[] = [];
    public drawOptions: DrawOption[] = [];
    public selectedDraw: DrawDetail | null = null;
    public searchedDraw: DrawDetail | null = null;
    public hasMore: boolean = false;
    public loadedOffset: number = 0;
    public latestDrawNo: number = 0;
    public pickerDrawNo: string | number = '';
    public manualDrawNo: string | number = '';
    public syncStatus: SyncStatus | null = null;
    public initialError: string = '';
    public loadMoreError: string = '';
    public detailError: string = '';
    public detailRetryDrawNo: number | null = null;
    public storeModalOpen: boolean = false;
    public storeLoading: boolean = false;
    public storeError: string = '';
    public storeDrawNo: number = 0;
    public storeRank: number = 1;
    public storePage: number = 1;
    public storeTotalCount: number = 0;
    public storeTotalWinningCount: number = 0;
    public storeTotalPages: number = 0;
    public storeHasPrevious: boolean = false;
    public storeHasNext: boolean = false;
    public storePageNumbers: number[] = [];
    public stores: WinningStore[] = [];
    private detailCache: { [drawNo: number]: DrawDetail } = {};
    private detailRetrySource: 'list' | 'search' = 'search';
    private previousBodyOverflow: string | null = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await (this.service as any).init();
        const allowed = await this.service.auth.allow('/access');
        if (!allowed) return;
        await this.load();
    }

    public ngOnDestroy() {
        this.unlockBodyScroll();
        this.setDetailModalScrollLocked(false);
        this.setDrawPickerScrollLocked(false);
    }

    public get latestDraw(): DrawSummary | null {
        return this.draws.length > 0 ? this.draws[0] : null;
    }

    public get pastDraws(): DrawSummary[] {
        return this.draws.slice(1);
    }

    public get recentDrawOptions(): DrawOption[] {
        return this.drawOptions.slice(0, 6);
    }

    public async load() {
        this.loading = true;
        this.initialError = '';
        await this.service.render();

        try {
            const result: any = await wiz.call('overview');
            const data = result.data || {};
            if (result.code !== 200) {
                this.initialError = data.message || '당첨번호를 불러오지 못했습니다.';
                return;
            }

            this.draws = data.draws || [];
            this.loadedOffset = Number(data.next_offset || this.draws.length);
            this.hasMore = data.has_more === true;
            this.drawOptions = data.options || [];
            this.latestDrawNo = Number(data.latest_draw_no || 0);
            this.syncStatus = data.sync_status || null;
        } catch (error) {
            this.initialError = '네트워크 연결을 확인한 뒤 다시 시도해주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }

        const initialDrawNo = this.drawNoFromUrl();
        if (!this.initialError && initialDrawNo !== null) {
            await this.openDraw(initialDrawNo, 'search', false);
        }
    }

    public async retryLoad() {
        await this.load();
    }

    public async toggleDrawPicker(event: Event) {
        event.stopPropagation();
        if (this.loading || this.latestDrawNo < 1) return;
        this.drawPickerOpen = !this.drawPickerOpen;
        this.setDrawPickerScrollLocked(this.drawPickerOpen);
        await this.service.render();
    }

    @HostListener('document:click')
    public async closeDrawPicker() {
        if (!this.drawPickerOpen) return;
        this.drawPickerOpen = false;
        this.setDrawPickerScrollLocked(false);
        await this.service.render();
    }

    @HostListener('document:keydown.escape')
    public async closeOverlayWithEscape() {
        if (this.storeModalOpen) {
            await this.closeStoreModal();
            return;
        }
        if (this.selectedDraw) {
            await this.closeDrawDetail();
            return;
        }
        await this.closeDrawPicker();
    }

    @HostListener('window:popstate')
    public async restoreDrawFromHistory() {
        const drawNo = this.drawNoFromUrl();
        if (drawNo === null) {
            this.selectedDraw = null;
            this.searchedDraw = null;
            this.setDetailModalScrollLocked(false);
            await this.service.render();
            return;
        }
        await this.openDraw(drawNo, 'search', false);
    }

    public async selectDrawOption(drawNo: number) {
        if (this.findingDrawNo !== null) return;
        this.pickerDrawNo = drawNo;
        await this.openDraw(drawNo, 'search');
    }

    public async openManualDraw() {
        const drawNo = Number(this.manualDrawNo);
        if (!Number.isInteger(drawNo) || drawNo < 1 || drawNo > this.latestDrawNo) {
            await this.service.modal.error(
                '1회부터 ' + this.latestDrawNo + '회 사이의 숫자를 입력해주세요.'
            );
            return;
        }
        await this.openDraw(drawNo, 'search');
    }

    public async openDraw(
        drawNo: number,
        source: 'list' | 'search' = 'search',
        updateHistory: boolean = true
    ) {
        if (this.findingDrawNo !== null) return;
        this.findingDrawNo = drawNo;
        this.detailError = '';
        this.detailRetryDrawNo = null;
        await this.service.render();

        try {
            let detail = this.detailCache[drawNo];
            if (!detail) {
                const result: any = await wiz.call('draw_detail', { draw_no: drawNo });
                const data = result.data || {};
                if (result.code !== 200) {
                    this.detailError = data.message || '당첨 결과를 불러오지 못했습니다.';
                    this.detailRetryDrawNo = drawNo;
                    this.detailRetrySource = source;
                    return;
                }
                detail = data.draw as DrawDetail;
                this.detailCache[drawNo] = detail;
            }

            const existsInList = this.draws.some(
                (draw: DrawSummary) => draw.draw_no === detail.draw_no
            );
            this.selectedDraw = detail;
            this.searchedDraw = source === 'search' && !existsInList ? detail : null;
            this.pickerDrawNo = detail.draw_no;
            this.manualDrawNo = '';
            this.drawPickerOpen = false;
            this.setDrawPickerScrollLocked(false);
            this.detailRetryDrawNo = null;
            this.setDetailModalScrollLocked(true);
            if (updateHistory) this.updateDrawUrl(detail.draw_no);
        } catch (error) {
            this.detailError = '네트워크 연결을 확인한 뒤 다시 시도해주세요.';
            this.detailRetryDrawNo = drawNo;
            this.detailRetrySource = source;
        } finally {
            this.findingDrawNo = null;
            await this.service.render();
        }
    }

    public async loadMore() {
        if (!this.hasMore || this.loadingMore) return;
        this.loadingMore = true;
        this.loadMoreError = '';
        await this.service.render();

        try {
            const result: any = await wiz.call('list_draws', {
                offset: this.loadedOffset,
                limit: 5
            });
            const data = result.data || {};
            if (result.code !== 200) {
                this.loadMoreError = data.message || '이전 회차를 불러오지 못했습니다.';
                return;
            }

            const next: DrawSummary[] = data.draws || [];
            const known = new Set<number>(
                this.draws.map((draw: DrawSummary) => draw.draw_no)
            );
            this.draws = [
                ...this.draws,
                ...next.filter((draw: DrawSummary) => !known.has(draw.draw_no))
            ];
            if (
                this.searchedDraw &&
                this.draws.some(
                    (draw: DrawSummary) => draw.draw_no === this.searchedDraw?.draw_no
                )
            ) {
                this.searchedDraw = null;
            }
            this.loadedOffset = Number(
                data.next_offset === undefined
                    ? this.loadedOffset + next.length
                    : data.next_offset
            );
            this.hasMore = data.has_more === true;
        } catch (error) {
            this.loadMoreError = '네트워크 연결을 확인한 뒤 다시 시도해주세요.';
        } finally {
            this.loadingMore = false;
            await this.service.render();
        }
    }

    public async toggleDraw(draw: DrawSummary, source: 'list' | 'search' = 'list') {
        if (this.selectedDraw?.draw_no === draw.draw_no) {
            await this.closeDrawDetail();
            return;
        }
        await this.openDraw(draw.draw_no, source);
    }

    public async closeDrawDetail() {
        this.selectedDraw = null;
        this.detailError = '';
        this.detailRetryDrawNo = null;
        this.setDetailModalScrollLocked(false);
        this.updateDrawUrl(null);
        await this.service.render();
    }

    public async clearSearchedDraw() {
        this.searchedDraw = null;
        await this.closeDrawDetail();
    }

    public async retryDrawDetail() {
        if (this.detailRetryDrawNo === null) return;
        const drawNo = this.detailRetryDrawNo;
        const source = this.detailRetrySource;
        await this.openDraw(drawNo, source);
    }

    public async openStoreModal() {
        if (!this.selectedDraw || !this.hasStoreSummary()) return;
        this.storeDrawNo = this.selectedDraw.draw_no;
        this.storeRank = this.storeCount(1) > 0 ? 1 : 2;
        this.storePage = 1;
        this.storeTotalCount = 0;
        this.storeTotalWinningCount = this.storeCount(this.storeRank);
        this.storeTotalPages = 0;
        this.storeHasPrevious = false;
        this.storeHasNext = false;
        this.storePageNumbers = [];
        this.storeModalOpen = true;
        this.storeError = '';
        this.stores = [];
        this.lockBodyScroll();
        await this.service.render();
        await this.loadWinningStores();
    }

    public async closeStoreModal() {
        this.storeModalOpen = false;
        this.storeError = '';
        this.unlockBodyScroll();
        await this.service.render();
    }

    public async selectStoreRank(rank: number) {
        if (this.storeLoading || ![1, 2].includes(rank)) return;
        if (this.storeRank === rank && this.stores.length) return;
        this.storeRank = rank;
        this.storePage = 1;
        this.storeTotalCount = 0;
        this.storeTotalWinningCount = this.storeCount(rank);
        this.storeTotalPages = 0;
        this.storeHasPrevious = false;
        this.storeHasNext = false;
        this.storePageNumbers = [];
        await this.loadWinningStores();
    }

    public async previousStorePage() {
        if (this.storeLoading || !this.storeHasPrevious) return;
        this.storePage -= 1;
        await this.loadWinningStores();
    }

    public async nextStorePage() {
        if (this.storeLoading || !this.storeHasNext) return;
        this.storePage += 1;
        await this.loadWinningStores();
    }

    public async retryWinningStores() {
        await this.loadWinningStores();
    }

    public async goToStorePage() {
        if (this.storeLoading) return;
        if (this.storePage < 1 || this.storePage > this.storeTotalPages) return;
        await this.loadWinningStores();
    }

    public async loadWinningStores() {
        if (!this.storeModalOpen || this.storeDrawNo < 1) return;
        this.storeLoading = true;
        this.storeError = '';
        this.stores = [];
        await this.service.render();

        try {
            const result: any = await wiz.call('winning_stores', {
                draw_no: this.storeDrawNo,
                prize_rank: this.storeRank,
                page: this.storePage
            });
            const data = result.data || {};
            if (result.code !== 200) {
                this.storeError = data.message || '당첨 판매점을 불러오지 못했습니다.';
                this.stores = [];
                return;
            }

            this.stores = data.stores || [];
            this.storePage = Number(data.page || 1);
            this.storeTotalCount = Number(data.total_count || 0);
            this.storeTotalWinningCount = Number(data.total_winning_count || 0);
            this.storeTotalPages = Number(data.total_pages || 0);
            this.storeHasPrevious = data.has_previous === true;
            this.storeHasNext = data.has_next === true;
            this.storePageNumbers = Array.from(
                { length: this.storeTotalPages },
                (_item, index) => index + 1
            );
        } catch (error) {
            this.storeError = '네트워크 연결을 확인한 뒤 다시 시도해주세요.';
            this.stores = [];
        } finally {
            this.storeLoading = false;
            await this.service.render();
        }
    }

    public isSelected(drawNo: number) {
        return this.selectedDraw?.draw_no === drawNo;
    }

    public isFinding(drawNo: number) {
        return this.findingDrawNo === drawNo;
    }

    public trackByDrawNo(_index: number, draw: DrawSummary) {
        return draw.draw_no;
    }

    public numberClass(number: number) {
        if (number <= 10) return 'ball-yellow';
        if (number <= 20) return 'ball-blue';
        if (number <= 30) return 'ball-red';
        if (number <= 40) return 'ball-gray';
        return 'ball-green';
    }

    public currency(value: number | null | undefined) {
        if (value === null || value === undefined || !Number.isFinite(Number(value))) {
            return '정보 없음';
        }
        return new Intl.NumberFormat('ko-KR').format(Number(value)) + '원';
    }

    public integer(value: number | null | undefined) {
        return new Intl.NumberFormat('ko-KR').format(Number(value || 0));
    }

    public shortDate(value: string) {
        return String(value || '').slice(0, 10);
    }

    public fullDate(value: string) {
        const [year, month, day] = this.shortDate(value).split('-');
        if (!year || !month || !day) return this.shortDate(value);
        return year + '년 ' + Number(month) + '월 ' + Number(day) + '일';
    }

    public pickerDate(value: string) {
        const [_year, month, day] = this.shortDate(value).split('-');
        if (!month || !day) return this.shortDate(value);
        return Number(month) + '월 ' + Number(day) + '일';
    }

    public storeCount(rank: number) {
        if (!this.selectedDraw) return 0;
        return (this.selectedDraw.store_summary || [])
            .filter((item: StoreSummary) => item.prize_rank === rank)
            .reduce((total: number, item: StoreSummary) => {
                return total + Number(item.store_count || 0);
            }, 0);
    }

    public hasStoreSummary() {
        return Boolean(this.selectedDraw?.store_summary?.length);
    }

    public storeName(store: WinningStore) {
        return String(store.store_name || '').trim() || '판매점 이름 없음';
    }

    public storeAddress(store: WinningStore) {
        const address = String(store.full_address || '').trim();
        if (address) return address;
        return [store.province, store.district].filter(Boolean).join(' ');
    }

    public storeMethodClass(method: string | null) {
        if (method === '자동') return 'bg-blue-50 text-blue-700';
        if (method === '수동') return 'bg-amber-50 text-amber-800';
        if (method === '반자동') return 'bg-emerald-50 text-emerald-700';
        return 'bg-slate-100 text-slate-500';
    }

    public storePrimaryMeta(store: WinningStore) {
        const methods = store.method_counts || [];
        const winningCount = Number(store.winning_count || 0);
        if (!methods.length) {
            return winningCount > 1 ? '총 ' + this.integer(winningCount) + '건' : '';
        }
        if (methods.length === 1) {
            return winningCount > 1
                ? methods[0].method + ' · ' + this.integer(winningCount) + '건'
                : methods[0].method;
        }
        return '총 ' + this.integer(winningCount) + '건';
    }

    public storePrimaryMetaClass(store: WinningStore) {
        const methods = store.method_counts || [];
        if (methods.length === 1) return this.storeMethodClass(methods[0].method);
        return 'bg-violet-50 text-violet-700';
    }

    public storeMethodBreakdown(store: WinningStore) {
        return (store.method_counts || [])
            .map(method => method.method + ' ' + this.integer(method.count))
            .join(' · ');
    }

    public storePhoneHref(store: WinningStore) {
        const phone = String(store.phone || '').replace(/[^0-9+]/g, '');
        return phone ? 'tel:' + phone : null;
    }

    public trackByStoreId(_index: number, store: WinningStore) {
        return store.id;
    }

    private lockBodyScroll() {
        if (typeof document === 'undefined' || this.previousBodyOverflow !== null) return;
        this.previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
    }

    private unlockBodyScroll() {
        if (typeof document === 'undefined' || this.previousBodyOverflow === null) return;
        document.body.style.overflow = this.previousBodyOverflow;
        this.previousBodyOverflow = null;
    }

    private setDetailModalScrollLocked(locked: boolean) {
        if (typeof document === 'undefined') return;
        const root = document.querySelector('app-root');
        if (root) root.classList.toggle('draw-detail-modal-open', locked);
    }

    private setDrawPickerScrollLocked(locked: boolean) {
        if (typeof document === 'undefined') return;
        const root = document.querySelector('app-root');
        if (root) root.classList.toggle('draw-picker-modal-open', locked);
    }

    public syncStatusLabel() {
        const status = this.syncStatus?.status;
        if (status === 'success') return '최신 결과 업데이트 완료';
        if (status === 'no_new_data') return '동행복권 확인 완료';
        if (status === 'running') return '최신 결과 확인 중';
        if (status === 'failed') return '최신 결과 확인이 늦어지고 있어요';
        return '동행복권 결과';
    }

    public syncStatusClass() {
        const status = this.syncStatus?.status;
        if (status === 'failed') return 'text-red-600';
        if (status === 'running') return 'text-amber-700';
        return 'text-emerald-600';
    }

    public syncStatusTime() {
        const value = this.syncStatus?.finished_at || this.syncStatus?.started_at;
        if (!value) return '';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '';
        return new Intl.DateTimeFormat('ko-KR', {
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            timeZone: 'Asia/Seoul'
        }).format(date);
    }

    private drawNoFromUrl(): number | null {
        try {
            const value = new URLSearchParams(window.location.search).get('draw');
            if (!value) return null;
            const drawNo = Number(value);
            return Number.isInteger(drawNo) && drawNo > 0 ? drawNo : null;
        } catch (error) {
            return null;
        }
    }

    private updateDrawUrl(drawNo: number | null) {
        try {
            const path = window.location.pathname;
            const nextUrl = drawNo === null ? path : path + '?draw=' + drawNo;
            const currentUrl = window.location.pathname + window.location.search;
            if (nextUrl !== currentUrl) {
                window.history.pushState({ drawNo: drawNo }, '', nextUrl);
            }
        } catch (error) { }
    }
}

export default PageDrawsComponent;